import React, {useState} from 'react';
import {Link, Navigate, useParams} from 'react-router-dom';
import {connect} from 'react-redux';
import {verify} from '../actions/authAction'
import true_mark1 from '../assets/image/true_mark1.webp'
const Activate = ({verify}) => {
    const [verified, setVerified] = useState(false)
    const { uid, token } = useParams()
    const verify_account = e => {
        e.preventDefault();
        verify(uid, token)
        setVerified(true)
    }

    if (verified) {
        return (
            <div className='reset-success'>
                <img className="image_mark" src={true_mark1} alt='true mark image' width={350} height={350}/>
                <p className='reset-success-message'>Your account are Activate Successfly, you can login now!</p>
            </div>
        )
    }
    console.log(uid, token)
    return (
        <div className='container-verify'>
            <div>
                <h1 className='text-verify'> Verified your Account:</h1>
                <button onClick={verify_account} className='btn-verify'>
                    Verify
                </button>
            </div>
        </div>
    )
}

export default connect(null, {verify})(Activate);